/**
 * 게시글 카드 "..." 메뉴: 링크 복사, 신고하기, 이 회원 차단하기.
 * AJAX 처리 후 모달로 결과 표시, 완료/실패 시 드롭다운 닫기.
 */
import { Modal } from "../../utils/Modal";

const SEL_WRAP = "[data-post-more]";
const SEL_BTN = ".comm-post__more";
const SEL_MENU = ".comm-post__more-menu";
const SEL_ITEM = ".comm-post__more-item";

function getApiUrls(): { reportUrl: string; blockUrl: string } {
  const page = document.querySelector(".comm-page");
  return {
    reportUrl: page?.getAttribute("data-api-report-url") ?? "",
    blockUrl: page?.getAttribute("data-api-block-url") ?? "",
  };
}

function getCsrf(): string {
  return (
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content ??
    (document.querySelector('input[name="_token"]') as HTMLInputElement | null)?.value ??
    ""
  );
}

function closeAllMenus(): void {
  document.querySelectorAll(SEL_MENU).forEach((el) => {
    el.classList.remove("is-open");
  });
  document.querySelectorAll(SEL_BTN).forEach((btn) => {
    btn.setAttribute("aria-expanded", "false");
  });
}

function closeMenu(wrap: Element): void {
  const menu = wrap.querySelector(SEL_MENU);
  const btn = wrap.querySelector(SEL_BTN);
  if (menu) menu.classList.remove("is-open");
  if (btn) btn.setAttribute("aria-expanded", "false");
}

export function initPostMoreMenus(): void {
  const wraps = document.querySelectorAll(SEL_WRAP);
  if (!wraps.length) return;

  const { reportUrl, blockUrl } = getApiUrls();
  const csrf = getCsrf();

  wraps.forEach((wrap) => {
    const btn = wrap.querySelector(SEL_BTN);
    const menu = wrap.querySelector(SEL_MENU);
    if (!btn || !menu) return;

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = menu.classList.contains("is-open");
      closeAllMenus();
      if (!isOpen) {
        menu.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
      }
    });

    menu.addEventListener("click", (e) => e.stopPropagation());
  });

  document.addEventListener("click", () => {
    closeAllMenus();
  });

  document.querySelectorAll(`${SEL_WRAP} ${SEL_ITEM}`).forEach((item) => {
    item.addEventListener("click", async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const target = e.currentTarget as HTMLElement;
      if (target.hasAttribute("disabled") || target.getAttribute("aria-disabled") === "true" || target.classList.contains("--own-post")) {
        return;
      }
      const wrap = target.closest(SEL_WRAP);
      if (!wrap) return;

      const action = target.getAttribute("data-action");
      let message = "";

      if (action === "copy-link") {
        const url = (e.currentTarget as HTMLElement).getAttribute("data-post-url") ?? "";
        const fullUrl = url.startsWith("http") ? url : `${window.location.origin}${url.startsWith("/") ? "" : "/"}${url}`;
        try {
          await navigator.clipboard.writeText(fullUrl);
          message = "링크가 복사되었습니다.";
        } catch {
          message = "링크 복사에 실패했습니다.";
        }
        closeMenu(wrap);
        await Modal.alert(message);
        return;
      }

      if (action === "report") {
        if (!reportUrl) {
          closeMenu(wrap);
          await Modal.alert("기능을 사용할 수 없습니다.");
          return;
        }
        const postId = (e.currentTarget as HTMLElement).getAttribute("data-post-id") ?? "";
        const body = new FormData();
        body.append("target_type", "post");
        body.append("target_id", postId);
        body.append("reason_code", "other");
        if (csrf) body.append("_token", csrf);
        try {
          const res = await fetch(reportUrl, {
            method: "POST",
            body,
            headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
          });
          let data: { success?: boolean; message?: string } = {};
          try {
            data = (await res.json()) as { success?: boolean; message?: string };
          } catch {
            message = "응답을 확인할 수 없습니다.";
          }
          message = message || (data.message ?? (data.success ? "신고가 접수되었습니다." : "처리에 실패했습니다."));
        } catch {
          message = "요청에 실패했습니다.";
        }
        closeMenu(wrap);
        await Modal.alert(message);
        return;
      }

      if (action === "block") {
        if (!blockUrl) {
          closeMenu(wrap);
          await Modal.alert("기능을 사용할 수 없습니다.");
          return;
        }
        const authorUserId = (e.currentTarget as HTMLElement).getAttribute("data-author-user-id") ?? "";
        const body = new FormData();
        body.append("blocked_user_id", authorUserId);
        if (csrf) body.append("_token", csrf);
        try {
          const res = await fetch(blockUrl, {
            method: "POST",
            body,
            headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
          });
          let data: { success?: boolean; message?: string } = {};
          try {
            data = (await res.json()) as { success?: boolean; message?: string };
          } catch {
            message = "응답을 확인할 수 없습니다.";
          }
          message = message || (data.message ?? (data.success ? "차단되었습니다." : "처리에 실패했습니다."));
        } catch {
          message = "요청에 실패했습니다.";
        }
        closeMenu(wrap);
        await Modal.alert(message);
      }
    });
  });
}
